import CompLayout from "@/pcomponents/comp/layout/layout";
import ViewOneWeekOfStuArea from "@/pages/comp/edu/lecture/view_time_table/common/one_week_of_stu";

function ViewOneWeekOfStu() {
  return (
    <CompLayout isConTitle={false}>
      <ViewOneWeekOfStuArea></ViewOneWeekOfStuArea>
    </CompLayout>
  );
}

export default ViewOneWeekOfStu;